import { useEffect } from 'react';
import { Link, createFileRoute } from '@tanstack/react-router';
import { AccessibilityFeatures, Button, LUDOLIO_SUPPORT_EMAIL, SkipLink } from '@ludolio/shared-ui';

export const Route = createFileRoute('/docs/accessibility')({
  component: AccessibilityPage,
});

function AccessibilityPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = 'Accessibility';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col bg-[hsl(var(--color-background))] text-[hsl(var(--color-foreground))]">
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_15%_15%,hsl(var(--color-primary)/0.14),transparent_30%),radial-gradient(circle_at_85%_10%,hsl(var(--color-primary)/0.08),transparent_28%),linear-gradient(180deg,hsl(var(--color-muted)/0.45),transparent_42%)]" />

      <SkipLink />

      <header className="relative border-b border-[hsl(var(--color-border))] bg-[hsl(var(--color-background))]/90 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-3xl items-center justify-between px-6">
          <Link to="/" aria-label="Ludolio" className="flex shrink-0 items-center">
            <img src="/logo.png" alt="" className="h-8 w-auto" />
          </Link>
          <Button asChild size="sm">
            <Link to="/">Sign in</Link>
          </Button>
        </div>
      </header>

      <main id="main-content" tabIndex={-1} className="relative mx-auto w-full max-w-3xl flex-1 px-6 py-16 outline-none">
        <AccessibilityFeatures />
      </main>

      <footer className="relative border-t border-[hsl(var(--color-border))]">
        <div className="mx-auto max-w-3xl px-6 py-6 text-sm text-muted-foreground">
          If you have an accessibility question, email{' '}
          <a className="font-medium text-foreground underline" href={`mailto:${LUDOLIO_SUPPORT_EMAIL}`}>
            {LUDOLIO_SUPPORT_EMAIL}
          </a>
        </div>
      </footer>
    </div>
  );
}
